import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface ReferralTermsContentProps {
  onBack: () => void;
}

const ReferralTermsContent: React.FC<ReferralTermsContentProps> = ({ onBack }) => {
  return (
    <div className="p-4">
      {/* Back Button */}
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-gray-700 hover:text-gray-900 mb-6 transition-colors"
      >
        <ArrowLeft size={20} />
        <span className="font-medium">Back</span>
      </button>

      {/* Terms Content */}
      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-6">General Referral Guidelines</h2>
        
        <div className="space-y-4 text-sm text-gray-700">
          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              This promotion is available to new Creators Archive users who sign up through your link only - 
              we want to share the fashion experience with fresh eyes and grow our creative community!
            </p>
          </div>

          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              Rewards are earned once your invitee creates a new account and publishes their first archive post. 
              No FitCoins for inactive or incomplete referrals will be granted.
            </p>
          </div>

          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              We do not grant FitCoins to users with disposable or high-risk email accounts. All referral emails 
              are checked by a third-party email reputation service to ensure high-quality participation and no 
              referral fraud.
            </p>
          </div>

          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              Each new user can generate only one (1) reward. No stacking or loophole hunting.
            </p>
          </div>

          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              Please avoid spamming or misusing your referral link to get FitCoins without bringing legitimate 
              users to the platform. Our algorithms actively monitor referral engagement and alert us on unusual 
              activity.
            </p>
          </div>

          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              If we detect suspicious or non-compliant activity, we have a right to withhold rewards or 
              deactivate your referral link.
            </p>
          </div>

          <div className="flex gap-3">
            <span className="text-gray-900 flex-shrink-0">•</span>
            <p>
              We may update, pause, or discontinue this program at any time as we continue to experiment and improve.
            </p>
          </div>

          <div className="mt-6 pt-4 border-t border-gray-200">
            <p className="text-gray-600">
              For complete terms of service and referral rules, see{' '}
              <a 
                href="/terms" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-purple-600 hover:text-purple-700 underline font-medium"
              >
                Creators Archive Terms
              </a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralTermsContent;
